import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const eventClassImporterSelectors = importerSelectors(
  'eventClass.importer',
);

export default eventClassImporterSelectors;
